var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftBar", staticStyle: { color: "#fff" } },
    [
      _c("v-drawer", { attrs: { direction: "left", width: "26%" } }, [
        _c(
          "div",
          {
            staticClass: "animated fadeInLeftBig",
            staticStyle: { height: "100%", width: "100%" },
          },
          [
            _c(
              "bar-card",
              { staticClass: "lefts", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("基地种植规模排行")]),
                _c("div", { staticClass: "panelContent" }, [_c("left-top")], 1),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts2", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("种植面积分布/品种占比(2023)")]),
                _c("div", { staticClass: "panelContent" }, [_c("left-mid")], 1),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts3", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("种植基地")]),
                _c("div", { staticClass: "panelContent" }, [_c("left-bot")], 1),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }